module.exports = __webpack_public_path__ + "static/img/ic_community_f.214cecc5.png";